import { ApolloClient, InMemoryCache, split, HttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { getMainDefinition } from "@apollo/client/utilities";
import { createClient } from "graphql-ws";
import generatedIntrospection from "../../gql/__generated__/introspection-result.json";
import { typePolicies } from "./typePolicies";

const httpLink = new HttpLink({
  uri: import.meta.env.VITE_GRAPHQL_API_URL
});

function getGraphQLWsUrl(): string {
  const graphqlAPIUrl: string = import.meta.env.VITE_GRAPHQL_API_URL;
  if (!graphqlAPIUrl.startsWith("http")) {
    return window.location.origin.replace("http", "ws") + graphqlAPIUrl;
  }
  return graphqlAPIUrl.replace("http", "ws");
}

const wsLink = new GraphQLWsLink(
  createClient({
    url: getGraphQLWsUrl()
  })
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
});

export const apolloCache = new InMemoryCache({
  typePolicies,
  possibleTypes: generatedIntrospection.possibleTypes
});

export const getApolloClient = (
  accessToken: string,
  organizationSlug: string
) => {
  const authLink = setContext((_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        ...(organizationSlug && { organization: organizationSlug }),
        ...(accessToken && { authorization: `Bearer ${accessToken}` })
      }
    };
  }).concat(errorLink);

  return new ApolloClient({
    link: authLink.concat(splitLink),
    cache: apolloCache,
    connectToDevTools: true
  });
};
